(function () {
  /**
   * Inicializa uma instância da seção (o container [data-interactive-product-hotspots]).
   * @param {Element} root
   */
  function init(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.interactiveProductHotspotsReady === '1') return;

    var element = root;
    element.dataset.interactiveProductHotspotsReady = '1';

    var max = parseInt(element.dataset.hotspotMax || '0', 10);
    if (!max) return;

    /**
     * @param {number} index
     */
    function setActive(index) {
      if (index < 1) index = max;
      if (index > max) index = 1;
      element.dataset.activeHotspot = String(index);
    }

    element.querySelectorAll('[data-hotspot-trigger]').forEach(function (trigger) {
      if (!(trigger instanceof HTMLElement)) return;
      trigger.addEventListener('click', function () {
        var idx = parseInt(trigger.dataset.hotspotIndex || '', 10);
        if (!isNaN(idx)) setActive(idx);
      });
    });

    var prev = element.querySelector('[data-hotspot-prev]');
    if (prev) {
      prev.addEventListener('click', function () {
        setActive(parseInt(element.dataset.activeHotspot || '1', 10) - 1);
      });
    }

    var next = element.querySelector('[data-hotspot-next]');
    if (next) {
      next.addEventListener('click', function () {
        setActive(parseInt(element.dataset.activeHotspot || '1', 10) + 1);
      });
    }
  }

  /**
   * @param {Document|Element|EventTarget|null} [scope]
   */
  function initAll(scope) {
    var container = scope instanceof Element || scope instanceof Document ? scope : document;
    container.querySelectorAll('[data-interactive-product-hotspots]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
